import styled from 'styled-components';

export const FilterWrapper = styled.div`
  margin-bottom: 24px;
`;

export const FrameImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  object-fit: contain;
  z-index: 1;
`;
export const SegmentationsImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  object-fit: contain;
  z-index: 2;
  /* Removed pointer-events: none to allow interaction with individual segmentations */
`;

export const CoverWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: black;
  width: 100%;
  height: 300px; /* More reasonable height */
`;

export const ToggleButtonWrapper = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 2;

  .ant-btn {
    background: rgba(40, 40, 40, 0.85) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    color: rgba(255, 255, 255, 0.9) !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25) !important;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(60, 60, 60, 0.9) !important;
      color: white !important;
      transform: scale(1.05);
      box-shadow: 0 3px 12px rgba(0, 0, 0, 0.3) !important;
    }

    &:active {
      transform: scale(0.98);
    }
  }
`;
export const AcceptAllButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
`;

export const SegmentationOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

export const PixelTracker = styled.div`
  position: absolute;
  inset: 0;
  z-index: 3;
  pointer-events: auto;
`;

export const HoverSvg = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  pointer-events: auto;
  /* Ensure fills have no visible stroke/border except explicit highlighted contours */
  path {
    stroke: none !important;
    stroke-width: 0 !important;
  }
  /* Allow paths marked as highlighted to show their stroke (override the general rule) */
  path.highlighted-contour {
    stroke: unset !important;
    stroke-width: unset !important;
  }
  circle {
    stroke: none !important;
  }
`;

export const TooltipBox = styled.div`
  position: absolute;
  transform: translate(-50%, -100%);
  z-index: 4;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  padding: 4px 8px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  font-size: 12px;
  line-height: 1.2;
  white-space: nowrap;
  display: flex;
  align-items: center;
`;

export const TooltipBadge = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  margin-right: 6px;
`;

export const SegmentationToggleButton = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
`;

export const ToggleButtonContainer = styled.div`
  position: absolute;
  z-index: 10;

  .ant-btn {
    background: rgba(40, 40, 40, 0.85) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    color: rgba(255, 255, 255, 0.9) !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25) !important;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(60, 60, 60, 0.9) !important;
      color: white !important;
      transform: scale(1.05);
      box-shadow: 0 3px 12px rgba(0, 0, 0, 0.3) !important;
    }

    &:active {
      transform: scale(0.98);
    }
  }
`;

export const StatsBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
`;

export const StatsContentWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 30px;
  padding: 10px 20px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  background-color: #f9f9f9;
  margin-bottom: 20px;
`;
